/* MyPad Product JavaScript - Simple & Clean */

document.addEventListener('DOMContentLoaded', function() {
  initializeAccordion();
  initMyPadVariantPicker();
});

// Simple Accordion Functionality
function initializeAccordion() {
  if (typeof window.mypadProductDescription === 'undefined') {
    return;
  }

  const accordionContainer = document.getElementById('mypad-accordion');
  if (!accordionContainer) {
    return;
  }

  // Simple description parsing
  const description = window.mypadProductDescription;
  if (!description) return;

  // Create a single section if no headings found, or split by headings
  const sections = parseDescription(description);
  
  // Generate accordion
  accordionContainer.innerHTML = sections.map((section, index) => `
    <div class="mypad-accordion__item">
      <button class="mypad-accordion__header ${index === 0 ? 'active' : ''}" 
              onclick="toggleAccordion(this)" 
              aria-expanded="${index === 0}">
        <h3 class="mypad-accordion__title">${section.title}</h3>
        <svg class="mypad-accordion__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
      </button>
      <div class="mypad-accordion__content ${index === 0 ? 'active' : ''}">
        <div class="mypad-accordion__body">
          ${section.content}
        </div>
      </div>
    </div>
  `).join('');
}

function parseDescription(description) {
  // Try to split by headings
  const headings = description.match(/<h[2-4][^>]*>.*?<\/h[2-4]>/gi);
  
  if (headings && headings.length > 0) {
    const sections = [];
    let remainingContent = description;
    
    headings.forEach(heading => {
      const title = heading.replace(/<[^>]*>/g, '').trim();
      const startIndex = remainingContent.indexOf(heading);
      const endIndex = startIndex + heading.length;
      
      // Get content after this heading until next heading or end
      let content = remainingContent.substring(endIndex);
      const nextHeadingMatch = content.match(/<h[2-4][^>]*>/);
      if (nextHeadingMatch) {
        content = content.substring(0, nextHeadingMatch.index);
      }
      
      if (title && content.trim()) {
        sections.push({
          title: title,
          content: content.trim()
        });
      }
      
      remainingContent = remainingContent.substring(endIndex);
    });
    
    return sections.length > 0 ? sections : [{ title: 'Produktbeschreibung', content: description }];
  }
  
  // No headings found, create single section
  return [{ title: 'Produktbeschreibung', content: description }];
}

function toggleAccordion(header) {
  const content = header.nextElementSibling;
  const isActive = header.classList.contains('active');

  // Close all
  document.querySelectorAll('.mypad-accordion__header').forEach(h => {
    h.classList.remove('active');
    h.setAttribute('aria-expanded', 'false');
    h.nextElementSibling.classList.remove('active');
  });

  // Open clicked one if it wasn't active
  if (!isActive) {
    header.classList.add('active');
    header.setAttribute('aria-expanded', 'true');
    content.classList.add('active');
  }
}

// MyPad Product JavaScript

function initMyPadVariantPicker() {
  console.log('🟢 MyPad variant picker initializing...');
  
  // Look for the variant-radios component
  const variantRadios = document.querySelector('variant-radios.mypad-variant-picker');
  console.log('🔍 Found variant-radios component:', !!variantRadios);
  
  if (!variantRadios) {
    console.log('❌ No MyPad variant-radios component found');
    return;
  }
  
  // Handle MyPad card visual selection
  const mypadRadios = variantRadios.querySelectorAll('.mypad-variant-card input[type="radio"]');
  console.log('📋 Found MyPad radio inputs:', mypadRadios.length);
  
  mypadRadios.forEach((radio, index) => {
    console.log(`📍 Radio ${index}:`, {
      name: radio.name,
      value: radio.value,
      checked: radio.checked
    });
    
    radio.addEventListener('change', function() {
      console.log('🔄 MyPad radio changed:', this.value, 'checked:', this.checked);
      
      if (this.checked) {
        // Update visual selected state for MyPad cards
        const variantCards = variantRadios.querySelectorAll('.mypad-variant-card');
        variantCards.forEach(card => card.classList.remove('selected'));
        this.closest('.mypad-variant-card').classList.add('selected');
        
        console.log('✅ Updated MyPad visual selection for:', this.value);
        
        // The variant-radios component will handle all the price updates automatically
        // through its built-in renderProductInfo() method
      }
    });
  });
  
  // Handle label clicks to ensure proper selection
  const variantLabels = variantRadios.querySelectorAll('.mypad-variant-card__label');
  console.log('🏷️ Found MyPad labels:', variantLabels.length);
  
  variantLabels.forEach(label => {
    label.addEventListener('click', function(e) {
      const radio = this.querySelector('input[type="radio"]');
      if (radio && !radio.disabled) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
  
  // Listen for variant changes from the component to update variant card prices
  variantRadios.addEventListener('change', function(e) {
    if (e.target.type === 'radio') {
      console.log('🔔 Variant-radios change event:', e.target.value);
      updateVariantCardPricesFromSelection();
    }
  });
  
  // Initialize variant card prices
  setTimeout(() => {
    updateVariantCardPricesFromSelection();
  }, 100);
  
  console.log('✅ MyPad variant picker initialized - using standard variant-radios component');
}

function updateVariantCardPricesFromSelection() {
  console.log('🎯 Updating variant card prices...');
  
  const variantRadios = document.querySelector('variant-radios.mypad-variant-picker');
  if (!variantRadios) return;
  
  // Get current customer type
  const customerType = getCurrentCustomerType();
  console.log('👤 Current customer type:', customerType);
  
  // Get variant data from the JSON script
  const variantScript = variantRadios.querySelector('script[type="application/json"]');
  if (!variantScript) {
    console.log('❌ Variant JSON data not found');
    return;
  }
  
  const variants = JSON.parse(variantScript.textContent);
  console.log('📊 Found variants:', variants.length);
  
  // Update each variant card price
  const variantCards = variantRadios.querySelectorAll('.mypad-variant-card');
  variantCards.forEach((card, index) => {
    const radio = card.querySelector('input[type="radio"]');
    const priceElement = card.querySelector('.mypad-variant-card__price');
    
    if (radio && priceElement) {
      // Find the variant that matches this option value
      const matchingVariant = variants.find(variant => variant.option1 === radio.value);
      
      if (matchingVariant) {
        // Get the main product price element to copy the price format
        const mainPriceElement = document.querySelector('[id^="price-"] .price--product .price-item--regular');
        
        if (mainPriceElement) {
          const b2cPrice = mainPriceElement.getAttribute('data-b2c');
          const b2bPrice = mainPriceElement.getAttribute('data-b2b');
          
          // If we have the main product B2C/B2B prices, calculate variant prices proportionally
          if (b2cPrice && b2bPrice) {
            const mainB2cCents = parseMoneyToCents(b2cPrice);
            const mainB2bCents = parseMoneyToCents(b2bPrice);
            
            // Calculate variant prices based on the ratio
            const variantB2cCents = matchingVariant.price;
            const vatRatio = mainB2cCents / mainB2bCents;
            const variantB2bCents = Math.round(variantB2cCents / vatRatio);
            
            const variantB2cPrice = formatMoney(variantB2cCents);
            const variantB2bPrice = formatMoney(variantB2bCents);
            
            // Display the appropriate price
            const displayPrice = customerType === 'b2c' ? variantB2cPrice : variantB2bPrice;
            priceElement.textContent = displayPrice;
            
            console.log(`✅ Updated variant card ${index + 1}:`, {
              option: radio.value,
              b2c: variantB2cPrice,
              b2b: variantB2bPrice,
              displaying: displayPrice
            });
          } else {
            // Fallback: just show the variant price
            priceElement.textContent = formatMoney(matchingVariant.price);
          }
        } else {
          // Fallback: just show the variant price
          priceElement.textContent = formatMoney(matchingVariant.price);
        }
      }
    }
  });
  
  console.log('🎉 Variant card prices updated');
}

function parseMoneyToCents(moneyString) {
  // Parse money string like "€1.380,00" or "1.380,00 €" to cents
  const cleanPrice = moneyString.replace(/[€$£¥\s]/g, '');
  
  if (cleanPrice.includes(',')) {
    // European format: "1.380,00" -> 138000 cents
    const parts = cleanPrice.split(',');
    const euros = parseInt(parts[0].replace(/\./g, '') || '0');
    const cents = parseInt(parts[1] || '0');
    return euros * 100 + cents;
  } else if (cleanPrice.includes('.')) {
    // US format: "1380.00" -> 138000 cents
    const priceFloat = parseFloat(cleanPrice);
    return Math.round(priceFloat * 100);
  } else {
    // No decimal separator, assume whole euros
    return parseInt(cleanPrice || '0') * 100;
  }
}

function getCurrentCustomerType() {
  const vatSwitcher = document.querySelector('.vat-switcher-custom .disclosure__button .value');
  if (!vatSwitcher) return 'b2b';
  
  const text = vatSwitcher.textContent.trim();
  return (text.includes('Geschäft') || text.includes('Geschäftskunde')) ? 'b2b' : 'b2c';
}

function formatMoney(cents) {
  // Simple money formatting - in production, use Shopify's money formatting
  const amount = cents / 100;
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(amount);
}

// Handle media gallery video autoplay
function initMediaGallery() {
  const videos = document.querySelectorAll('.mypad-media-item video');
  
  videos.forEach(video => {
    // Ensure videos are muted and can autoplay
    video.muted = true;
    video.playsInline = true;
    
    // Try to play the video
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        console.log('Video autoplay failed:', error);
      });
    }
  });
}

// Initialize media gallery on load
document.addEventListener('DOMContentLoaded', initMediaGallery);

// Re-initialize if content changes (for dynamic loading)
if (window.MutationObserver) {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if new video elements were added
        const hasNewVideos = Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && (
            node.matches('.mypad-media-item video') || 
            node.querySelector('.mypad-media-item video')
          )
        );
        
        if (hasNewVideos) {
          initMediaGallery();
        }
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function parseProductDescription() {
  if (typeof window.mypadProductDescription === 'undefined') {
    return;
  }

  const description = window.mypadProductDescription;
  if (!description) return;

  // Find the main description container and dynamic sections container
  const mainDescContainer = document.querySelector('#main-description-' + getSectionId());
  const dynamicContainer = document.querySelector('#dynamic-sections-' + getSectionId());
  
  if (!mainDescContainer || !dynamicContainer) return;

  // Keywords to look for
  const keywords = ['Zulassung', 'Zusatzfunktionen', 'Sonstige Merkmale'];
  
  // Parse the description
  const { mainContent, sections } = parseDescriptionBySections(description, keywords);
  
  // Set main description
  mainDescContainer.innerHTML = mainContent;
  
  // Create dynamic sections
  sections.forEach(section => {
    const sectionElement = createAccordionSection(section.title, section.content);
    dynamicContainer.appendChild(sectionElement);
  });
}

function parseDescriptionBySections(description, keywords) {
  let mainContent = description;
  const sections = [];
  
  keywords.forEach(keyword => {
    // Look for h3 tags with the keyword
    const regex = new RegExp(`<h3[^>]*>\\s*${keyword}\\s*</h3>`, 'gi');
    const match = description.match(regex);
    
    if (match) {
      const keywordHeading = match[0];
      const startIndex = description.indexOf(keywordHeading);
      
      if (startIndex !== -1) {
        // Find the end of this section (next h3 or end of content)
        let endIndex = description.length;
        const remainingContent = description.substring(startIndex + keywordHeading.length);
        
        // Look for next h3 tag
        const nextH3Match = remainingContent.match(/<h3[^>]*>/i);
        if (nextH3Match) {
          endIndex = startIndex + keywordHeading.length + nextH3Match.index;
        }
        
        // Extract the section content
        const sectionContent = description.substring(startIndex + keywordHeading.length, endIndex).trim();
        
        if (sectionContent) {
          sections.push({
            title: keyword,
            content: sectionContent
          });
          
          // Remove this section from main content
          const fullSection = description.substring(startIndex, endIndex);
          mainContent = mainContent.replace(fullSection, '');
        }
      }
    }
  });
  
  // Clean up main content
  mainContent = mainContent.trim();
  
  return { mainContent, sections };
}

function createAccordionSection(title, content) {
  const details = document.createElement('details');
  details.innerHTML = `
    <summary>
      <h2 class="h4 accordion__title">${title}</h2>
      <svg class="icon icon-caret" role="presentation" focusable="false" viewBox="0 0 10 6">
        <path fill-rule="evenodd" clip-rule="evenodd" d="m9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708Z" fill="currentColor">
        </path>
      </svg>
    </summary>
    <div class="accordion__content">
      <div class="accordion__content-inner rte">
        ${content}
      </div>
    </div>
  `;
  
  return details;
}

function getSectionId() {
  const sectionElement = document.querySelector('[data-section]');
  return sectionElement ? sectionElement.dataset.section : '';
}

// Expose functions globally
window.toggleAccordion = toggleAccordion; 